import { render, staticRenderFns } from "./CreateNpa.vue?vue&type=template&id=0446b2ff&scoped=true"
import script from "./CreateNpa.vue?vue&type=script&lang=js"
export * from "./CreateNpa.vue?vue&type=script&lang=js"
import style0 from "./CreateNpa.vue?vue&type=style&index=0&id=0446b2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446b2ff",
  null
  
)

export default component.exports